"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var theme_1 = require("../../utils/theme");
var context_1 = require("./context");
var BOUNDING_LEN = 4;
var Item = (function (_super) {
    tslib_1.__extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, style = _a.style, color = _a.color, children = _a.children, textColor = _a.textColor, prefixCls = _a.prefixCls, className = _a.className, selected = _a.selected, hoverEffect = _a.hoverEffect, rest = tslib_1.__rest(_a, ["style", "color", "children", "textColor", "prefixCls", "className", "selected", "hoverEffect"]);
            var renderedChildren = color && children;
            var colorStyle = {};
            if (color) {
                colorStyle.background = color;
            }
            if (textColor) {
                colorStyle.color = textColor;
            }
            return (h(context_1.ColorpickerContext.Consumer, null, function (size) { return (h(context_1.GroupContext.Consumer, null, function (selectedColors) { return (h("div", tslib_1.__assign({ className: _this.getClasses(classNames, selectedColors), style: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, style), colorStyle), { width: size, height: size, '--width': size + BOUNDING_LEN + "px" }) }, rest), renderedChildren)); })); }));
        };
        return _this;
    }
    Item.prototype.isSelected = function (selectedColors) {
        var _a = this.props, selected = _a.selected, color = _a.color;
        if (selected !== undefined) {
            return selected;
        }
        return selectedColors.includes(color);
    };
    Item.prototype.getClasses = function (classNames, selectedColors) {
        var _a;
        var _b = this.props, prefixCls = _b.prefixCls, className = _b.className, color = _b.color, children = _b.children, hoverEffect = _b.hoverEffect;
        var renderedChildren = color && children;
        return classNames(prefixCls, className, prefixCls + "-" + (hoverEffect === 'enlarge' ? 'enlarge' : 'bound'), (_a = {},
            _a[prefixCls + "-selected"] = this.isSelected(selectedColors),
            _a[prefixCls + "-with-text"] = renderedChildren,
            _a[prefixCls + "-white"] = /^#(fff){1,2}$/i.test(color),
            _a[prefixCls + "-null"] = color === null,
            _a[prefixCls + "-empty"] = !color && (color !== null),
            _a));
    };
    Item.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Item;
}(React.Component));
exports.default = Item;
Item.defaultProps = {
    prefixCls: 'dui-colorpicker-item'
};
